import { FC } from "react";

import { Logo } from "@/components/Logo";
import { translate } from "@/utils/translations";
import { Suggestions } from "@/components/Suggestions";

interface EmptyStateProps {
  styles: {
    assistantLabel: string;
    mainContent: string;
    mainTitle: string;
    titleSection: string;
  };
  onActionClick: (actionText: string) => void;
}

export const EmptyState: FC<EmptyStateProps> = ({ onActionClick, styles }) => {
  return (
    <div className={styles.mainContent}>
      <div className={styles.titleSection}>
        <p className={styles.assistantLabel}>
          <Logo size={18} withoutText />
          Assistant
        </p>
        <h2 className={styles.mainTitle}>{translate("How can I help?")}</h2>
      </div>
      {/* <Suggestions handleActionClick={onActionClick} /> */}
    </div>
  );
};
